<template>
  <section class="container">
    <div class="swiper">
      <!-- <svg class="swiper-bg" width="100vw" height="100vh" xmlns="http://www.w3.org/2000/svg">
      
        <defs>
          <linearGradient y2="0" x2="1" y1="0" x1="0" id="svg_2">
            <stop offset="0" stop-color="#fb9c96" />
            <stop offset="1" stop-color="#fab373" />
          </linearGradient>
        </defs>

        <g>
          <title>Layer 1</title>
          <path
            stroke-opacity="0"
            id="svg_1"
            d="m883.49998,-5.78137c32.00001,50.00001 156.00004,404.00009 -72.00002,554.00012c-228.00005,150.00004 -194.00004,528.00012 -192.00004,540.00012c2,12.00001 1326.0003,12.00001 1324.5005,11.78137c1.4998,0.21864 -2.5002,-1119.78162 -4,-1118.00024c1.4998,-1.78138 -1062.50044,-1.78138 -1064.00023,0c1.49979,-1.78138 -24.50021,-37.78138 7.49979,12.21863z"
            stroke-width="1.5"
            stroke="#0f0f00"
            fill="url(#svg_2)"
          />
        </g>
      </svg>-->

      <div class="animo-building" style="
          background-image: url('http://www.vedamobi.com/assets/website/images/index/build.png');
        ">
        <img class="animo-money" src="http://www.vedamobi.com/assets/website/images/index/money.png" />
        <div class="box1"></div>
        <div class="boxShow boxShow1"></div>
        <div class="box2"></div>
        <div class="boxShow boxShow2"></div>
        <div class="box3"></div>
        <div class="boxShow boxShow3"></div>
        <div class="box4"></div>
        <div class="boxShow boxShow4"></div>
        <div class="box5"></div>
        <div class="boxShow boxShow5"></div>
        <div class="box6"></div>
        <div class="boxShow boxShow6"></div>
        <div class="box3D-wrap">
          <div class="box3D-animoWrap box3D1-animoWrap">
            <div class="box3D box3D1">
              <div class="leftPage"></div>
              <div class="rightPage"></div>
              <div class="topPage"></div>
            </div>
          </div>
          <div class="box3D-animoWrap box3D2-animoWrap">
            <div class="box3D box3D2">
              <div class="leftPage"></div>
              <div class="rightPage"></div>
              <div class="topPage"></div>
            </div>
          </div>

          <div class="box3D-animoWrap box3D3-animoWrap">
            <div class="box3D box3D3">
              <div class="leftPage"></div>
              <div class="rightPage"></div>
              <div class="topPage"></div>
            </div>
          </div>

          <div class="box3D-animoWrap box3D4-animoWrap">
            <div class="box3D box3D4">
              <div class="leftPage"></div>
              <div class="rightPage"></div>
              <div class="topPage"></div>
            </div>
          </div>

          <div class="box3D-animoWrap box3D5-animoWrap">
            <div class="box3D box3D5">
              <div class="leftPage"></div>
              <div class="rightPage"></div>
              <div class="topPage"></div>
            </div>
          </div>
          <div class="box3D-animoWrap box3D6-animoWrap">
            <div class="box3D box3D6">
              <div class="leftPage"></div>
              <div class="rightPage"></div>
              <div class="topPage"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="web-box title-wrap">
        <div class="text-wrap">
          <p class="animo-title">微动科技&emsp;VEDA</p>
        </div>

        <div class="cuboid"></div>
        <div class="text-wrap">
          <p class="animo-content">一站式优选流量技术服务提供商</p>
        </div>
      </div>
      <img class="mobile-topimg" src="http://www.vedamobi.com/assets/website/images/index/城市.png" />
    </div>
    <div class="web-box" style="margin-top: 110px; text-align: center">
      <p class="home-title">
        <span>多场景优选流量</span>
      </p>
      <p class="home-content">根据不同营销目的，选择合适投放的广告位</p>
      <div class="phone-Mask">
        <div class="phone-wrap web-show">
          <phone-one class="phone1" style="margin-top: 8rem"></phone-one>
          <phone-two class="phone2" style="margin-top: 6rem"></phone-two>
          <phone-three class="phone3" style="margin-top: 4rem"></phone-three>
          <phone-four class="phone4" style="margin-top: 2rem"></phone-four>
        </div>
        <div class="mobile-phone-wrap mobile-show">
          <swiper>
            <swiper-slide>
              <phone-one></phone-one>
            </swiper-slide>
            <swiper-slide>
              <phone-two></phone-two>
            </swiper-slide>
            <swiper-slide>
              <phone-three></phone-three>
            </swiper-slide>
            <swiper-slide>
              <phone-four></phone-four>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </div>
    <div class="slanting-bar-wrap">
      <div class="slanting-bar"></div>
      <div class="slanting-content-wrap">
        <div class="slanting-content web-box">
          <div class="animo1">
            <p class="home-title">
              <img src="http://www.vedamobi.com/assets/website/images/index/icon1.png" />
              <span>一站式整合营销方案</span>
            </p>
            <p class="home-content">
              对接优质媒体资源，精准定位目标人群，一站式程序化投放，为客户提供专业、高效的整合营销方案
            </p>
          </div>
          <img class="right-img" src="http://www.vedamobi.com/assets/website/images/index/moreHeard.png" />
        </div>
      </div>
    </div>
    <div class="web-box server-wrap">
      <img src="http://www.vedamobi.com/assets/website/images/index/icon2.png" />
      <p class="home-title">专业的服务水平</p>
      <p class="home-content">
        强大的自研技术，资深的投放团队，全心全意为客户服务
      </p>
      <div class="card-wrap">
        <div class="phone1 card">
          <div class="border-icon">
            <span class="icon1">&#xe6fd;</span>
            <span class="icon2">&#xe6fd;</span>
            <span class="icon3">&#xe6fd;</span>
          </div>
          <p>自研投放引擎</p>
          <p>多年大数据挖掘技术</p>
          <p>强大的广告投放辅助插件</p>
          <p>...</p>
        </div>
        <div class="card phone2">
          <div class="border-icon" style="
              background-image: linear-gradient(
                to bottom left,
                #fea54e,
                #fa8e62
              );
            ">
            <span class="icon4">&#xe653;</span>
            <span class="icon5">&#xe653;</span>
            <span class="icon6">&#xe653;</span>
          </div>
          <p>多媒体垂直流量</p>
          <p>领先行业的创意制作水平</p>
          <p>订制化真人原创素材</p>
          <p>...</p>
        </div>
        <div class="card phone3">
          <div class="border-icon" style="
              background-image: linear-gradient(to bottom, #dd57c7, #f8364e);
            ">
            <span class="icon4" style="font-size: 60px">&#xe600;</span>
            <span class="icon5" style="font-size: 80px">&#xe600;</span>
            <span class="icon6" style="font-size: 100px">&#xe600;</span>
          </div>
          <p>365天全年无休</p>
          <p>专业资深人士带队</p>
          <p>多平台投放经验</p>
          <p>...</p>
        </div>
      </div>
      <!-- 手机端滑动卡片 -->
      <swiper class="mobile-swiper" ref="mySwiper">
        <!-- slides -->
        <swiper-slide>
          <div class="card">
            <div class="border-icon">
              <span class="icon1">&#xe6fd;</span>
              <span class="icon2">&#xe6fd;</span>
              <span class="icon3">&#xe6fd;</span>
            </div>
            <p>自研投放引擎</p>
            <p>多年大数据挖掘技术</p>
            <p>强大的广告投放辅助插件</p>
            <p>...</p>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="card">
            <div class="border-icon" style="
                background-image: linear-gradient(
                  to bottom left,
                  #fea54e,
                  #fa8e62
                );
              ">
              <span class="icon4">&#xe653;</span>
              <span class="icon5">&#xe653;</span>
              <span class="icon6">&#xe653;</span>
            </div>
            <p>多媒体垂直流量</p>
            <p>领先行业的创意制作水平</p>
            <p>订制化真人原创素材</p>
            <p>...</p>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="card">
            <div class="border-icon" style="
                background-image: linear-gradient(to bottom, #dd57c7, #f8364e);
              ">
              <span class="icon4" style="font-size: 60px">&#xe600;</span>
              <span class="icon5" style="font-size: 80px">&#xe600;</span>
              <span class="icon6" style="font-size: 100px">&#xe600;</span>
            </div>
            <p>365天全年无休</p>
            <p>专业资深人士带队</p>
            <p>多平台投放经验</p>
            <p>...</p>
          </div>
        </swiper-slide>
      </swiper>
    </div>
    <div class="web-box customer-wrap" style="margin-top: 110px">
      <div class="customer-item item1">
        <div class="icon-card1">
          <img src="http://www.vedamobi.com/assets/website/images/index/LOGO墙/16.png" />
        </div>
        <div class="icon-card2">
          <img src="http://www.vedamobi.com/assets/website/images/index/LOGO墙/17.png" />
        </div>
        <div class="icon-card3">
          <img src="http://www.vedamobi.com/assets/website/images/index/LOGO墙/18.png" />
        </div>
      </div>
      <div class="customer-item item2">
        <div class="icon-card4">
          <img src="http://www.vedamobi.com/assets/website/images/index/LOGO墙/7.png" />
        </div>
        <div class="icon-card5">
          <img src="http://www.vedamobi.com/assets/website/images/index/LOGO墙/8.png" />
        </div>
        <div class="icon-card6">
          <img src="http://www.vedamobi.com/assets/website/images/index/LOGO墙/9.png" />
        </div>
      </div>
      <div class="customer-item item2">
        <div class="mobile-show">
          <img src="http://www.vedamobi.com/assets/website/images/index/LOGO墙/1.png" />
        </div>
        <div class="icon-card7">
          <img src="http://www.vedamobi.com/assets/website/images/index/LOGO墙/5.png" />
        </div>
        <div class="icon-card8">
          <img src="http://www.vedamobi.com/assets/website/images/index/LOGO墙/6.png" />
        </div>
      </div>
      <div class="item3">
        <div class="center-card">
          <div>
            <p>他们选择了微动</p>
          </div>
          <p>客户持续投放，是微动前进的动力</p>
        </div>
        <div class="item3-flex">
          <div class="customer-item item2">
            <div class="icon-card9">
              <img src="http://www.vedamobi.com/assets/website/images/index/LOGO墙/2.png" />
            </div>
          </div>
          <div class="customer-item item2">
            <div class="icon-card10">
              <img src="http://www.vedamobi.com/assets/website/images/index/LOGO墙/1.png" />
            </div>
          </div>
        </div>
      </div>
      <div class="customer-item item2">
        <div class="mobile-show">
          <img src="http://www.vedamobi.com/assets/website/images/index/LOGO墙/2.png" />
        </div>
        <div class="icon-card11">
          <img src="http://www.vedamobi.com/assets/website/images/index/LOGO墙/3.png" />
        </div>
        <div class="icon-card12">
          <img src="http://www.vedamobi.com/assets/website/images/index/LOGO墙/4.png" />
        </div>
      </div>
      <div class="customer-item item2">
        <div class="icon-card13">
          <img src="http://www.vedamobi.com/assets/website/images/index/LOGO墙/10.png" />
        </div>
        <div class="icon-card14">
          <img src="http://www.vedamobi.com/assets/website/images/index/LOGO墙/11.png" />
        </div>
        <div class="icon-card15">
          <img src="http://www.vedamobi.com/assets/website/images/index/LOGO墙/12.png" />
        </div>
      </div>
      <div class="customer-item item1">
        <div class="icon-card16">
          <img src="http://www.vedamobi.com/assets/website/images/index/LOGO墙/13.png" />
        </div>
        <div class="icon-card17">
          <img src="http://www.vedamobi.com/assets/website/images/index/LOGO墙/14.png" />
        </div>
        <div class="icon-card18">
          <img src="http://www.vedamobi.com/assets/website/images/index/LOGO墙/15.png" />
        </div>
      </div>
    </div>
    <!-- <div class="foot-wrap">
      <div class="italics-bg"></div>
      <div class="ellipse-bg ellipse-bg1"></div>
      <div class="ellipse-bg ellipse-bg2"></div>
      <div class="ellipse-bg ellipse-bg3"></div>
    </div>-->
  </section>
</template>
<script>
import ScrollReveal from 'scrollreveal'
import phoneOne from '../components/phone1.vue'
import phoneTwo from '../components/phone2.vue'
import phoneThree from '../components/phone3.vue'
import phoneFour from '../components/phone4.vue'
export default {
  head() {
    return {
      title: '微动科技 - VEDA，一站式优选流量技术服务提供商',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content:
            '福建微动传媒科技有限公司是中国领先的流量技术服务提供商，致力于构建整合优质媒体资源的一站式广告生态系统'
        }
      ]
    }
  },
  data() {
    return {
      scrollReveal: ScrollReveal()
    }
  },
  components: {
    phoneOne,
    phoneTwo,
    phoneThree,
    phoneFour
  },

  mounted() {
    if (document.addEventListener) {
      // firefox
      document.addEventListener('DOMMouseScroll', this.scrollFunc, false)
    } // 滚动滑轮触发scrollFunc方法 //ie 谷歌
    window.onmousewheel = document.onmousewheel = this.scrollFunc
    //      ScrollReveal.reveal('.phone1', {
    //       // 动画的时长
    //       duration: 2000,
    //       // 延迟时间
    //       delay: 500,
    //       // 动画开始的位置，'bottom', 'left', 'top', 'right'
    //       origin: 'top',
    //       // 回滚的时候是否再次触发动画
    //       reset: false,
    //       // 在移动端是否使用动画
    //       mobile: false,
    //       // 滚动的距离，单位可以用%，rem等
    //       distance: '200px',
    //       // 其他可用的动画效果
    //       opacity: 0.001,
    //       easing: 'linear',
    //       scale: 0.9
    //     })
    //   }
    for (const index of [1, 2, 3, 4]) {
      this.scrollReveal.reveal(`.phone${index}`, {
        // 动画的时长
        duration: 500,
        // 延迟时间
        delay: 200 * (index - 1),
        // 动画开始的位置，'bottom', 'left', 'top', 'right'
        origin: 'bottom',
        // 回滚的时候是否再次触发动画
        reset: true,
        // 在移动端是否使用动画
        mobile: false,
        // 滚动的距离，单位可以用%，rem等
        distance: '200px',
        // 其他可用的动画效果
        opacity: 0.001,
        easing: 'linear'
      })
    }
    this.scrollReveal.reveal(`.home-title`, {
      duration: 600,
      delay: 0,
      origin: 'bottom',
      reset: true,
      mobile: false,
      distance: '200px',
      opacity: 0.001,
      easing: 'linear'
    })
    this.scrollReveal.reveal(`.home-content`, {
      duration: 600,
      delay: 300,
      origin: 'bottom',
      reset: true,
      mobile: false,
      distance: '200px',
      opacity: 0.001,
      easing: 'linear'
    })
    // 整合方案左边
    this.scrollReveal.reveal(`.animo1`, {
      duration: 600,
      delay: 0,
      origin: 'left',
      reset: true,
      mobile: false,
      distance: '400px',
      opacity: 0.001,
      easing: 'linear'
    })
    // 很多人头的那个
    this.scrollReveal.reveal(`.right-img`, {
      duration: 600,
      delay: 0,
      origin: 'right',
      reset: true,
      mobile: false,
      distance: '800px',
      opacity: 0.001,
      easing: 'linear'
    })

    // 合作客户中间块
    this.scrollReveal.reveal(`.center-card`, {
      duration: 800,
      delay: 0,
      origin: 'bottom',
      reset: true,
      mobile: false,
      distance: '200px',
      opacity: 0.001,
      easing: 'linear'
    })
    // 合作客户 做随机显示
    for (let i = 1; i <= 18; i++) {
      this.scrollReveal.reveal(`.icon-card${i}`, {
        duration: 500,
        delay: 800 + 1000 * Math.random(),
        reset: true,
        mobile: false,
        opacity: 0.001,
        easing: 'linear'
      })
    }
  },
  beforeDestroy() {
    if (document && document.removeEventListener) {
      document.removeEventListener('DOMMouseScroll', this.scrollFunc)
    }

    window.onmousewheel = document.onmousewheel = function () { }
  },
  methods: {
    // scrollTo() {
    //   window.scrollTo(0, 1001);
    // },
    scrollFunc(e) {
      e = e || window.event
      if (e.wheelDelta) {
        // 第一步：先判断浏览器IE，谷歌滑轮事件
        if (e.wheelDelta > 0) {
          // 当滑轮向上滚动时
          this.scrollTop()
        }
        if (e.wheelDelta < 0) {
          this.scrollBottom()
        }
      } else if (e.detail) {
        // Firefox滑轮事件
        if (e.detail > 0) {
          // 当滑轮向上滚动时
          this.scrollTop()
        }
        if (e.detail < 0) {
          // 当滑轮向下滚动时
          this.scrollBottom()
        }
      }
    },
    getClientHeight() {
      let clientHeight = 0
      if (document.body.clientHeight && document.documentElement.clientHeight) {
        clientHeight =
          document.body.clientHeight < document.documentElement.clientHeight
            ? document.body.clientHeight
            : document.documentElement.clientHeight
      } else {
        clientHeight =
          document.body.clientHeight > document.documentElement.clientHeight
            ? document.body.clientHeight
            : document.documentElement.clientHeight
      }
      return clientHeight
    },
    scrollTop() {
      const clientHeight = this.getClientHeight()
      if (document.documentElement.scrollTop <= clientHeight) {
        if (!!window.ActiveXObject || 'ActiveXObject' in window) {
        } else {
          window.scrollTo({ top: 0, behavior: 'smooth' })
        }
      }
    },
    scrollBottom() {
      const clientHeight = this.getClientHeight()
      if (document.documentElement.scrollTop < clientHeight) {
        if (!!window.ActiveXObject || 'ActiveXObject' in window) {
        } else {
          window.scrollTo({
            top: clientHeight,
            behavior: 'smooth'
          })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
}

.swiper {
  min-width: 1366px;

  width: 100%;
  height: 100vh;
  position: relative;
  overflow: hidden;

  .mobile-topimg {
    width: 100%;
    display: none;
  }

  .title-wrap {
    position: relative;
    z-index: 10;
    padding-top: 380px;

    .text-wrap {
      margin-left: 120px;
      width: 380px;
      height: 100px;
      overflow: hidden;
      text-align: center;
    }

    .animo-title {
      font-weight: 100;
      font-size: 50px;
      animation: titleAnimo 2s;
    }

    .animo-content {
      font-size: 26px;
      animation: contentAnimo 2s;
    }

    .cuboid {
      margin-left: 120px;
      width: 370px;
      height: 8px;
      background-color: #5b6189;
      animation: cuboidAnimo 2s forwards;
    }
  }

  @keyframes cuboidAnimo {
    0% {
      transform: translateX(-370px);
    }

    20% {
      transform: translateX(20px);
    }

    40% {
      transform: translateX(0px);
    }

    70% {
      transform: translateX(0px);
    }

    100% {
      transform: translate(46px, -60px) scale(0.1, 0.3) rotate(360deg);
    }
  }

  @keyframes titleAnimo {
    0% {
      transform: translateY(100px);
    }

    40% {
      transform: translateY(100px);
    }

    70% {
      transform: translateY(0px);
    }

    100% {
      transform: translateY(0px);
    }
  }

  @keyframes contentAnimo {
    0% {
      transform: translateY(-40px);
    }

    40% {
      transform: translateY(-40px);
    }

    70% {
      transform: translateY(0px);
    }

    100% {
      transform: translateY(0px);
    }
  }

  .animo-building {
    z-index: 1;
    position: absolute;
    bottom: 0;
    right: 120px;
    width: 1000px;
    height: 640px;
    background: no-repeat bottom;

    .box1,
    .box2,
    .box3,
    .box4,
    .box5,
    .box6 {
      position: absolute;
      transform: rotateX(55deg) rotateZ(45deg);
      background-image: linear-gradient(to left, #ff465e, #fab373);
      z-index: 3;
    }

    .box1 {
      bottom: 45px;
      left: 228px;
      width: 44px;
      height: 44px;
      border-radius: 5px;
    }

    .box2 {
      bottom: 300px;
      right: 202px;
      width: 145px;
      height: 145px;
      border-radius: 10px;
    }

    .box3 {
      bottom: 280px;
      left: 216px;
      width: 20px;
      height: 20px;
      border-radius: 2px;
    }

    .box4 {
      bottom: 308px;
      left: 257px;
      width: 20px;
      height: 20px;
      border-radius: 2px;
    }

    .box5 {
      bottom: 338px;
      left: 298px;
      width: 20px;
      height: 20px;
      border-radius: 2px;
    }

    .box6 {
      bottom: 372px;
      left: 337px;
      width: 20px;
      height: 20px;
      border-radius: 2px;
    }

    .boxShow {
      position: absolute;
      opacity: 0.5;
      background-image: linear-gradient(to top, #fb9c96, transparent);
      z-index: 2;
      transform: scaleY(0);
      transform-origin: 0 100%;
    }

    .boxShow1 {
      width: 58px;
      height: 223px;
      bottom: 67px;
      left: 221px;
      animation: boxShow1 1s linear forwards;
    }

    .boxShow2 {
      width: 197px;
      height: 423px;
      bottom: 372px;
      right: 176px;
      animation: boxShow1 1s linear forwards;
    }

    .boxShow3 {
      width: 27px;
      height: 140px;
      bottom: 290px;
      left: 212px;
      animation: boxShow2 3s linear infinite;
      animation-delay: 0.5s;
    }

    .boxShow4 {
      width: 27px;
      height: 140px;
      bottom: 318px;
      left: 254px;
      animation: boxShow2 3s linear infinite;
      animation-delay: 1s;
    }

    .boxShow5 {
      width: 27px;
      height: 140px;
      bottom: 348px;
      left: 294px;

      animation: boxShow2 3s linear infinite;
      animation-delay: 1.5s;
    }

    .boxShow6 {
      width: 27px;
      height: 140px;
      bottom: 382px;
      left: 333px;
      animation: boxShow2 3s linear infinite;
      animation-delay: 2s;
    }
  }

  @keyframes boxShow2 {
    0% {
      transform: scaleY(0);
    }

    30% {
      transform: scaleY(1);
    }

    80% {
      transform: scaleY(1);
    }

    90% {
      transform: scaleY(0);
    }

    100% {
      transform: scaleY(0);
    }
  }

  .box3D-wrap {
    z-index: 4;
    position: absolute;
    bottom: 372px;
    right: 176px;
    width: 197px;
    height: 423px;

    .box3D-animoWrap {
      position: absolute;

      .box3D {
        transform: rotateY(-43deg) rotateZ(68deg) rotateY(-24deg);
        position: relative;
        transform-style: preserve-3d;

        .leftPage {
          background-color: #ff5b70;
        }

        .rightPage {
          transform-origin: 50% 100%;
          transform: rotateX(-90deg);
          background-color: #ffa06d;
          position: absolute;
          top: 0;
          left: 0;
        }

        .topPage {
          position: absolute;
          transform-origin: 0 100%;
          transform: rotateY(-90deg);
          background-color: #f7dcdb;
          top: 0;
          left: 0;
        }
      }
    }

    .box3D1-animoWrap {
      z-index: 10;
      bottom: 0;
      left: 100px;
      animation: box3DAnimo1 3s linear infinite;

      .box3D1 {
        div {
          width: 50px;
          height: 50px;
        }
      }
    }

    .box3D2-animoWrap {
      z-index: 9;
      bottom: 30px;
      left: 60px;
      animation: box3DAnimo2 2.1s linear infinite;

      .box3D2 {
        div {
          width: 30px;
          height: 30px;
        }
      }
    }

    .box3D3-animoWrap {
      z-index: 8;
      bottom: 80px;
      left: 120px;
      animation: box3DAnimo3 2.4s linear infinite;

      .box3D3 {
        div {
          width: 20px;
          height: 20px;
        }
      }
    }

    .box3D4-animoWrap {
      z-index: 7;
      bottom: 100px;
      left: 110px;
      animation: box3DAnimo3 1.8s linear infinite;

      .box3D4 {
        div {
          width: 10px;
          height: 10px;
        }
      }
    }

    .box3D5-animoWrap {
      z-index: 6;
      bottom: 80px;
      left: 30px;
      animation: box3DAnimo2 3s linear infinite;

      .box3D5 {
        div {
          width: 10px;
          height: 10px;
        }
      }
    }

    .box3D6-animoWrap {
      z-index: 5;
      bottom: 10px;
      right: 10px;
      animation: box3DAnimo6 3.6s linear infinite;

      .box3D6 {
        div {
          width: 20px;
          height: 20px;
        }
      }
    }
  }

  @keyframes box3DAnimo1 {
    0% {
      opacity: 0;
    }

    30% {
      opacity: 1;
    }

    80% {
      transform: translateY(-270px) scale(0.6);
      opacity: 1;
    }

    100% {
      transform: translateY(-320px) scale(0.5);
      opacity: 0;
    }
  }

  @keyframes box3DAnimo2 {
    0% {
      opacity: 0;
    }

    30% {
      opacity: 1;
    }

    80% {
      transform: translateY(-130px) scale(0.6);
      opacity: 1;
    }

    100% {
      transform: translateY(-150px) scale(0.5);
      opacity: 0;
    }
  }

  @keyframes box3DAnimo3 {
    0% {
      opacity: 0;
    }

    30% {
      opacity: 1;
    }

    80% {
      transform: translateY(-190px) scale(0.6);
      opacity: 1;
    }

    100% {
      transform: translateY(-220px) scale(0.5);
      opacity: 0;
    }
  }

  @keyframes box3DAnimo6 {
    0% {
      opacity: 0;
    }

    40% {
      opacity: 1;
    }

    70% {
      transform: translateY(-230px) scale(0.6);
      opacity: 1;
    }

    80% {
      transform: translateY(-250px) scale(0.5);
      opacity: 0;
    }

    100% {
      opacity: 0;
    }
  }

  .animo-money {
    position: absolute;
    bottom: 60px;
    left: 235px;
    width: 30px;
    height: 70px;
    animation: animoMoney 2s linear infinite alternate;
    z-index: 4;
  }
}

@keyframes animoMoney {
  0% {
    transform: translateY(-20px);
  }

  100% {
    transform: translateY(0px);
  }
}

@keyframes boxShow1 {
  0% {
    transform: scaleY(0);
  }

  100% {
    transform: scaleY(1);
  }
}

.mobile-show {
  display: none;
}

.content-title {
  text-align: center;
}

.phone-Mask {
  width: 100%;
  height: 20rem;
  overflow: hidden;
  position: relative;

  .phone-wrap {
    position: absolute;
    left: 0;
    bottom: -2rem;
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .mobile-phone-wrap {
    position: absolute;
    left: 0;
    bottom: -2rem;
    width: 100%;
    z-index: -1;
  }
}

.slanting-bar-wrap {
  position: relative;
  margin-top: -9rem;
  width: 100%;
  overflow: hidden;

  .slanting-bar {
    margin: 4rem 0;
    width: 100%;
    height: 450px;
    background-color: #fff;
    transform: skewY(-5deg);
    box-shadow: 0 0 10px rgba(187, 199, 255, 0.3);
  }

  .slanting-content-wrap {
    position: absolute;
    z-index: 3;
    width: 100%;
    top: 0;
    left: 0;

    .slanting-content {
      position: relative;
      display: flex;
      justify-content: space-between;
      margin-top: 200px;

      .home-title {
        line-height: 82px;
        margin-top: 2rem;

        span {
          margin-left: 30px;
          vertical-align: middle;
        }
      }

      .right-img {
        width: 29rem;
        height: 15.6rem;
        margin-left: 2rem;
      }

      .home-content {
        margin-top: 60px;
        line-height: 60px;
        font-size: 20px;
      }
    }
  }
}

.server-wrap {
  text-align: center;
  margin-top: 100px;

  .home-title {
    margin: 20px 0 10px 0;
  }

  .card-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 50px;
  }

  .mobile-swiper {
    display: none;
  }

  .card {
    width: 356px;
    text-align: center;
    padding: 50px 0 30px;
    border-radius: 10px;
    background-color: #fff;
    box-shadow: 0 0 8px #afbdfd;
    margin: 30px;

    &:hover {
      transform: scale(1.1) !important;
      cursor: pointer;
    }

    p {
      margin: 20px 0 0;
      line-height: 50px;
      font-size: 20px;
    }

    .border-icon {
      position: relative;
      width: 130px;
      height: 130px;
      border-radius: 100%;
      overflow: hidden;
      margin: 10px auto;
      background-image: linear-gradient(to bottom left, #fdaba7, #ff738c);

      span {
        display: block;
        font-family: 'iconfont';
        color: #fff;
      }

      .icon1 {
        font-size: 60px;
        padding-top: 30px;
        margin-right: 20px;
      }

      .icon2 {
        font-size: 90px;
        opacity: 0.6;
        position: absolute;
        top: -5px;
        left: 30px;
      }

      .icon3 {
        font-size: 120px;
        opacity: 0.3;
        position: absolute;
        top: -42px;
        left: 40px;
      }

      .icon4 {
        width: 130px;
        position: absolute;
        top: 0;
        left: 0;
        line-height: 130px;
        font-size: 50px;
      }

      .icon5 {
        width: 130px;
        opacity: 0.4;
        position: absolute;
        top: 0;
        left: 0;
        line-height: 130px;
        font-size: 90px;
      }

      .icon6 {
        width: 130px;
        opacity: 0.2;
        position: absolute;
        top: 0;
        left: 0;
        line-height: 130px;
        font-size: 130px;
      }
    }
  }
}

.customer-wrap {
  display: flex;
  align-items: center;

  .customer-item {
    margin: 0 13px;

    div {
      margin: 26px 0;
      border-radius: 10px;
      background-color: #fff;
      box-shadow: 0 0 8px #afbdfd;
      width: 100%;

      &:hover {
        transform: scale(1.2) !important;
        cursor: pointer;
      }

      img {
        width: 100%;
        height: auto;
        position: relative;
        top: 50%;
        /*偏移*/
        transform: translateY(-50%);
      }
    }
  }

  .item3-flex {
    display: flex;
  }

  .item1 {
    flex: 1;

    div {
      height: 3.4rem;
    }
  }

  .item2 {
    flex: 1;

    div {
      height: 4.6rem;
    }
  }

  .item3 {
    margin: 0 13px;
    flex: 2;

    .center-card {
      width: 100%;
      border-radius: 10px;
      background-color: #fff;
      box-shadow: 0 0 8px #afbdfd;
      height: 220px;
      text-align: center;
      line-height: 110px;
      font-size: 16px;
      overflow: hidden;

      div {
        height: 110px;
        width: 100%;
        background-image: linear-gradient(to bottom, #14cf9e, #08c2b9);

        p {
          color: #fff;
          font-size: 26px;
        }
      }
    }
  }
}

.foot-wrap {
  position: relative;
  margin-top: 100px;
  overflow: hidden;
  width: 100%;
  height: 1000px;
  background-image: linear-gradient(to right, #894bff, #63a5ff);

  .italics-bg {
    width: 120%;
    background-color: #fafbff;
    height: 200px;
    transform: rotate(-5deg);
    position: absolute;
    top: -100px;
    left: -10%;
    z-index: 4;
  }

  .ellipse-bg {
    position: absolute;
    width: 80%;
    height: 240px;
    background-image: linear-gradient(to right,
        transparent,
        rgba(255, 255, 255, 0.3));
    border-top-right-radius: 240px;
    border-bottom-right-radius: 240px;
  }

  .ellipse-bg1 {
    top: 0;
    left: 0;
  }

  .ellipse-bg2 {
    top: 200px;
    left: -50%;
  }

  .ellipse-bg3 {
    top: 500px;
    left: 40%;
  }
}

.swiper-bg {
  position: absolute;
  z-index: -1;
}

@media (max-width: 750px) {
  .swiper {
    min-width: auto;

    .animo-building {
      display: none;
    }

    .mobile-topimg {
      width: 100%;
      display: block;
      position: absolute;
      bottom: 0;
      left: 0;
    }

    .title-wrap {
      text-align: center;
      padding-top: 180px;

      .animo-title {
        font-size: 30px;
      }

      .text-wrap {
        margin-left: 0px;
        height: auto;
        width: 100%;
      }

      .animo-content {
        font-size: 20px;
      }

      .cuboid {
        animation: none;
        display: none;
      }
    }
  }

  .slanting-bar-wrap {
    .slanting-content-wrap {
      .slanting-content {
        display: block;
        margin-top: 100px;

        .home-title {
          margin-bottom: 20px;

          img {
            width: 60px;
            height: 60px;
          }

          span {
            font-size: 20px;
            font-weight: 600;
          }
        }

        .home-content {
          margin-top: 20px;
          font-size: 16px;
          line-height: 24px;
        }

        .right-img {
          margin-left: 0;
          width: 100%;
          height: auto;
        }
      }
    }
  }

  .server-wrap {
    margin-top: 40px;

    img {
      width: 80px;
      height: 80px;
    }

    .card-wrap {
      display: none;
    }

    .card {
      width: auto;

      box-shadow: none;
      margin: 0;
    }

    .mobile-swiper {
      display: block;
    }
  }

  .home-title {
    font-size: 20px;
    font-weight: 600;
  }

  .home-content {
    margin-top: 20px;
    font-size: 16px;
    line-height: 24px;
  }

  .customer-wrap {
    display: block;

    .item1,
    .item2 {
      div {
        width: calc(33% - 20px);
        height: 80px;
        float: left;
        margin: 10px;
      }
    }

    .item3 {
      .center-card {
        width: 80%;
        margin: 20px auto;
        height: 160px;

        div {
          height: 80px;
        }

        p {
          line-height: 80px;
        }
      }
    }

    .item3-flex {
      display: none;
    }
  }
}
</style>
